import { FC } from "react";
import React from "react";
import { Box, Snackbar, SnackbarCloseReason } from "@mui/material";
import "./Notifications.scss";
import { useAppState } from "../../../../Redux/ReduxHooks";
import { WellKnownToasters } from "./NotificationEntities";
import { Dispatch } from "../../../Dispatch";
import { BookingDataOwnership } from "../../../../Services/BookingEntities";

/** Generic component that implements material UI Snackbar component in order to display notifications to the user about various events during the booking flow of a Phone to CNP booking. Consumes data from PhoneToCnp redux store slice to decide what to display in the snackbar message. */
export const Toaster: FC = () => {

    const activeToasterType = useAppState(state => state.PhoneToCnp.ToasterToDisplay);
    const [open, setOpen] = React.useState(false);
    const booking = useAppState(state => state.PhoneToCnp.Booking)!;

    React.useEffect(() => {
        if (activeToasterType) setOpen(true);
    }, [activeToasterType]);

    if (!activeToasterType) return null;
    if (booking.DataOwnership !== BookingDataOwnership.WritableLink) return null; // Only display toasters for bookings that are owned by the user. Shared bookings (read-only) don't display toasters.)

    const toasterProps = WellKnownToasters[activeToasterType];

    function HandleClose(event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason,) {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        Dispatch.PhoneToCnp.HideToaster();
    }

    return (
        <Snackbar
            sx={{ "& .MuiSnackbarContent-root": { backgroundColor: "#535353", width: "auto", margin: "0 8px", borderRadius: "16px", padding: "16px" } }}
            className="toaster-snackbar"
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            open={open}
            autoHideDuration={8000}
            onClose={HandleClose}
            message={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <img src={toasterProps.Icon} />
                    <span>{toasterProps.DisplayText}</span>
                </Box>
            }
        />
    );
}